const colors = {
  transparent: 'transparent', // 0
  black: '#000000', // 1
  white: '#ffffff', // 2
  headingColor: '#0f2137',
  textColor: '#5d646d', // 3
  labelColor: '#767676', // 4
  inactiveField: '#f2f2f2', // 5
  inactiveButton: '#b7dbdd', // 6
  inactiveIcon: '#EBEBEB', // 7
  primary: 'rgba(76, 184, 196, 1)', // 8
  primaryHover: 'rgba(76, 184, 196, 1)', // 8
  primaryGradient: 'rgba(60, 211, 173, 1)',
  logo: '#b2f4e5',
  secondary: '#ff5b60', // 10
  secondaryLight: '#ff7ca0',
  tertiary: '#AA066B',
  tertiaryDark: '#6E0462',
  secondaryHover: '#FF282F', // 11
  yellow: '#fdb32a', // 12
  yellowHover: '#F29E02', // 13
  primaryBoxShadow: ' -6.691px 7.431px 20px 0px rgba(74, 47, 177, 0.2) ',
  secondGradStart: 'rgb(255, 148, 147)',
  secondaryGradEnd: 'rgb(255, 120, 162)',
};

export default colors;
